import React from "react";
import { Link } from "react-router-dom";
import { Mail, Shield, Instagram, Facebook } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="bg-[#1d3d3a] text-[#f5ebd9]/80 mt-16 hidden md:block">
      <div className="max-w-7xl mx-auto px-4 py-10 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div>
          <div className="mb-3 [&_img]:bg-[#f5ebd9] [&_img]:p-1">
            <Logo size={48} variant="light" />
          </div>
          <p className="text-xs text-[#f5ebd9]/60 leading-relaxed mt-3">Il marketplace esclusivo della Repubblica di San Marino. Compra, vendi, baratta o vinci all'asta.</p>
          <div className="flex items-center gap-2 mt-4">
            <a
              href="https://www.instagram.com/san_marino_market/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram San Marino Market"
              className="w-9 h-9 rounded-full bg-[#f5ebd9]/10 hover:bg-[#e86a24] text-[#f5ebd9] flex items-center justify-center transition-colors"
            >
              <Instagram className="w-4 h-4" />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61589405427852"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook San Marino Market"
              className="w-9 h-9 rounded-full bg-[#f5ebd9]/10 hover:bg-[#e86a24] text-[#f5ebd9] flex items-center justify-center transition-colors"
            >
              <Facebook className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-3 text-sm">Categorie</h4>
          <ul className="space-y-2 text-xs">
            <li><Link to="/categoria/elettronica" className="hover:text-white">Elettronica</Link></li>
            <li><Link to="/categoria/casa" className="hover:text-white">Casa e Arredamento</Link></li>
            <li><Link to="/categoria/moda" className="hover:text-white">Moda</Link></li>
            <li><Link to="/categoria/sport" className="hover:text-white">Sports e Hobby</Link></li>
            <li><Link to="/categoria/immobili" className="hover:text-white">Immobili</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-3 text-sm">Servizi</h4>
          <ul className="space-y-2 text-xs">
            <li><Link to="/aste" className="hover:text-white">Aste Live</Link></li>
            <li><Link to="/pubblica" className="hover:text-white">Pubblica Annuncio</Link></li>
            <li><span className="hover:text-white">Vetrine Premium</span></li>
            <li><span className="hover:text-white">Baratto Sicuro</span></li>
            <li><span className="hover:text-white">Come Funziona</span></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-3 text-sm">Contatti</h4>
          <ul className="space-y-2 text-xs">
            <li className="flex items-center gap-2"><Mail className="w-3 h-3"/>info@sanmarinomarket.sm</li>
            <li className="flex items-center gap-2"><Shield className="w-3 h-3"/>Acquisti protetti Stripe</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#0e2322]">
        <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-[#f5ebd9]/50">
          <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2 text-center sm:text-left">
            <span>© {new Date().getFullYear()} SAN MARINO MARKET · Repubblica di San Marino</span>
            <span className="hidden sm:inline">·</span>
            <span>
              Copyright{" "}
              <a
                href="https://ninfa.eu"
                target="_blank"
                rel="noopener noreferrer"
                className="font-bold text-amber-300 hover:text-amber-200"
                data-testid="footer-ninfa-link"
              >
                @ninfa.eu
              </a>
            </span>
          </div>
          <div className="flex gap-4">
            <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy-link">Privacy</Link>
            <Link to="/termini" className="hover:text-white" data-testid="footer-terms-link">Termini</Link>
            <Link to="/cookie" className="hover:text-white" data-testid="footer-cookie-link">Cookie</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
